module.exports = __webpack_public_path__ + "static/media/logooo.ca1c92d7.png";